import { createStyles } from "@mui/styles";

export const useStyles = (theme) =>
  createStyles({
    borderContainter: {
      border: "1px solid #f3f3f3",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    button: {
      borderRadius: "8px",
      padding: theme.spacing(2, 3),
      [theme.breakpoints.down("sm")]: {
        position: "none",
      },
      [theme.breakpoints.up("sm")]: {},
      [theme.breakpoints.up("md")]: {},
    },
    buttonText: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    cardContainer: {
      margin: theme.spacing(0, 1, 0, 1),
      padding: theme.spacing(1, 1, 1, 1),
      borderRadius: "8px",
      background: "#FFFFFF", //"#f3f3f347",
      // background: "#f0f5fb",
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.79)",
      [theme.breakpoints.down("sm")]: {
        // height: "40%"
      },
      [theme.breakpoints.up("sm")]: {},
      [theme.breakpoints.up("md")]: {},
    },
    cardItem: {
      borderRadius: "10px",
      padding: "4px",
      background: "#ffd900",
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
      transform: "scale(1)",
      "&:hover": {
        border: "1px solid #ffd900",
        transition: "width 1s, height 1s, transform 1s",
        transform: "scale(1.15)",
      },
    },
    container: {
      display: "flex",
      justifyContent: "center",
      // backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 0),
      backgroundColor: "#ffffff",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    containerCredential: {
      // background:
      //   "linear-gradient(to left top, #00802b, #323aa8, #323aa8, #ffd900)",
      /* background:
        "linear-gradient(to left top, #323aa8, #323aa8, #323aa8, #323aa8, #323aa8)",
      color: "#FFFFFF !important", */
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1, 0),
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(0),
        width: "35%",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(0),
        // borderRadius: theme.spacing(5),
        width: "35%",
      },
    },
    containerBanner: {
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(0, 0),
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(0, 0, 0, 2),
        width: "65%",
        justifyContent: "center",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(0, 0, 0, 2),
        width: "65%",
        justifyContent: "center",
      },
    },
    contentScroller: {
      justifyContent: "center",
      // backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 0),
      height: "466px",
      overflowY: "scroll",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        padding: theme.spacing(2, 0),
      },
      [theme.breakpoints.up("sm")]: {
        flexDirection: "row",
      },
      [theme.breakpoints.up("md")]: {
        flexDirection: "row",
      },
    },
    customBtn: {
      display: "flex",
      bottom: 0,
      [theme.breakpoints.down("sm")]: {
        justifyContent: "center",
        padding: theme.spacing(1, 0, 1, 0),
      },
      [theme.breakpoints.up("sm")]: {
        justifyContent: "center",
        padding: theme.spacing(1, 0, 1, 0),
      },
      [theme.breakpoints.up("md")]: {
        height: "100%",
        justifyContent: "center",
        padding: theme.spacing(1, 0, 1, 0),
      },
      position: "relative",
      marginTop: "60%",
    },
    containerButton: {
      position: "fixed",
      bottom: theme.spacing(0.5),
      width: "97.6%",
      left: 4,
      right: 4,
      bgcolor: "background.paper",
      py: 2,
      textAlign: "center",
      backgroundColor: "#ffffff",
    },
    containerInstaAccess: {
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(2),
        borderRadius: theme.spacing(5),
      },
    },
    errorMsg: {
      height: "20px",
      color: "#ff585d !important",
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1, 0, 1, 0),
        width: "auto",
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(1, 0, 1, 0),
        width: "auto",
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(1, 0, 1, 0),
        width: "100%",
      },
    },
    input: {
      justifyContent: "space-between",
      alignItems: "space-between",
      flexDirection: "column",
      [theme.breakpoints.down("sm")]: {
        height: "auto",
        padding: theme.spacing(0),
      },
      [theme.breakpoints.up("sm")]: {
        height: "auto",
        padding: theme.spacing(3),
      },
      [theme.breakpoints.up("md")]: {
        display: "flex",
        width: "100%",
      },
    },
    formOuter: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      [theme.breakpoints.down("sm")]: {
        minHeight: "80vh",
      },
      [theme.breakpoints.up("sm")]: {},
      [theme.breakpoints.up("md")]: {},
    },
    loaderBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    },
    mainCta: {
      width: "100%",
      whiteSpace: "nowrap",
      padding: theme.spacing(0, 3),
    },
    mobileInput: {
      border: 0,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.up("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "350px",
      },
    },
    mobileInputFocus: {
      width: "100%",
      border: 0,
      fontFamily: "Montserrat",
      fontSize: "15px",
      color: "#22334F",
      fontWeight: 600,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        marginTop: "0px",
      },
      [theme.breakpoints.up("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "350px",
      },
    },
    message: {
      display: "flex",
      // color: "#d1d1d1",
      fontSize: "12px !important",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
      [theme.breakpoints.up("sm")]: {
        width: "90%",
      },
      [theme.breakpoints.up("md")]: {
        width: "90%",
      },
    },
    bottomButton: {
      position: "sticky",
      bottom: 4,
      left: 4,
      right: 4,
      width: "98%",
    },
    verticalMiddle: {
      height: "64vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
  });
